var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutbutton01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 321 124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#be1e2d;}.cls-2{fill:#603913;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.55,107.34a45.34,45.34,0,0,1,0-90.68H261.62a45.34,45.34,0,0,1,0,90.68Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M261.62,19.66A42.34,42.34,0,0,1,304,62h0a42.34,42.34,0,0,1-42.34,42.34H69.55A42.34,42.34,0,0,1,27.22,62h0A42.34,42.34,0,0,1,69.55,19.66H261.62m0-6H69.55a48.34,48.34,0,0,0,0,96.68H261.62a48.34,48.34,0,0,0,0-96.68Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutbutton01);
export default __webpack_public_path__ + "static/media/Logout button-01.73d91576e49276a072a51881c9fba5fe.svg";
export { ForwardRef as ReactComponent };